var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "svg-renderer"
  }, [_c('div', {
    ref: "svgModel",
    staticClass: "svg-renderer-model"
  }, [_c('div', {
    ref: "svgRendererWrapper",
    staticClass: "svg-renderer-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.svgData)
    }
  }), _c('div', {
    staticClass: "svg-renderer-render",
    style: _vm.style('render-passes.png')
  }), !_vm.isApparel ? _c('div', {
    staticClass: "svg-renderer-shadow",
    style: _vm.style('top-shadow.png')
  }) : _vm._e()]), _vm._l(_vm.images, function (item, key) {
    return [_c('canvas', {
      key: key,
      ref: "".concat(key, "SvgCanvas"),
      refInFor: true,
      staticClass: "svg-renderer-canvas",
      attrs: {
        "width": "1024",
        "height": "1024"
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }